
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kfmcq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $8hmrm = parcelRequire("8hmrm");

var $gwZbZ = parcelRequire("gwZbZ");

var $6o7wX = parcelRequire("6o7wX");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");












var $1o4fX = parcelRequire("1o4fX");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $gh2Ps = parcelRequire("gh2Ps");




const $81c1a978552640a6$export$43c4a046864c3310 = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const skip = !isLoggedIn || !cloudId || edition !== (0, $euL71.ConfluenceEdition).PREMIUM;
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $gh2Ps.PremiumTrialEotQuery), {
        skip: skip,
        fetchPolicy: 'cache-first',
        interopApolloAggClient: true,
        onError: (error)=>{
            const eventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
                product: (0, $gwZbZ.Product).CONFLUENCE,
                team: (0, $6o7wX.Team).GROWTH_LUNA,
                experimentMeta: {
                    experimentKey: 'twcg-530_confluence_ai_in_editor_eot'
                },
                errorType: (0, $gwZbZ.ErrorType).GRAPHQL,
                errorMessage: error?.message,
                severity: (0, $gwZbZ.Severity).MEDIUM,
                source: 'useIsEligibleForPremiumTrialEot',
                additionalAttributes: {
                    cloudId: cloudId
                }
            });
            createAnalyticsEvent(eventPayload).fire();
        },
        __callerPackage__: "@confluence/experiment-ai-in-editor-eot"
    });
    const isPremiumEdition = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const trialEndDate = data?.license?.trialEndDate;
    const trialDaysLeft = (0, $1o4fX.getTrialDaysLeftFromTrialEndDate)(trialEndDate);
    const hasCCPBillingSystem = data?.license?.billingSourceSystem === 'CCP';
    const isInTrial = Boolean(trialDaysLeft && trialDaysLeft > 0);
    const hasReached5DaysRemaining = Boolean(trialDaysLeft && trialDaysLeft >= 0 && trialDaysLeft <= 5);
    const hasEligibleTrial = (0, $42omo.useMemo)(()=>{
        return isPremiumEdition && isLoggedIn && Boolean(cloudId) && hasCCPBillingSystem && isInTrial && hasReached5DaysRemaining;
    }, [
        isPremiumEdition,
        isLoggedIn,
        cloudId,
        hasCCPBillingSystem,
        isInTrial,
        hasReached5DaysRemaining
    ]);
    return {
        hasEligibleTrial: hasEligibleTrial,
        loading: loading,
        error: error?.message || null,
        trialEndDate: trialEndDate,
        trialDaysLeft: trialDaysLeft
    };
};



var $917iu = parcelRequire("917iu");

var $cTaz1 = parcelRequire("cTaz1");


var $17wUi = parcelRequire("17wUi");

const $192f920b4c5c17aa$export$cd716de99a2fcbd3 = 'confluence_ai_in_editor_eot_modal_last_shown_ts';
const $192f920b4c5c17aa$export$56a11e91bcd97371 = ()=>{
    const now = Date.now();
    (0, $17wUi.confluenceLocalStorageInstance).setItem($192f920b4c5c17aa$export$cd716de99a2fcbd3, now.toString());
};
const $192f920b4c5c17aa$export$711767a36b9978a = ()=>{
    const lastShownTs = (0, $17wUi.confluenceLocalStorageInstance).getItem($192f920b4c5c17aa$export$cd716de99a2fcbd3);
    return lastShownTs ? parseInt(lastShownTs, 10) : null;
};
const $192f920b4c5c17aa$export$145498fa852fa1d4 = (trialEndDate, trialDaysLeft)=>{
    //do not show after trial has ended
    if (!(0, $cTaz1.default)(new Date(trialEndDate))) return false;
    const lastShownTs = $192f920b4c5c17aa$export$711767a36b9978a();
    const daysSinceLastShown = lastShownTs ? (0, $917iu.default)(new Date(), new Date(lastShownTs)) : 0;
    //first time check
    const showModalAtFiveDaysBeforeEndOfTrial = trialDaysLeft === 5;
    if (showModalAtFiveDaysBeforeEndOfTrial && !lastShownTs) return true;
    if (trialDaysLeft === 3 && (!lastShownTs || daysSinceLastShown >= 2)) return true;
    if (trialDaysLeft === 1 && (!lastShownTs || daysSinceLastShown >= 2)) return true;
    return false;
};






var $aXWIB = parcelRequire("aXWIB");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");








var $ccHMk = parcelRequire("ccHMk");


var $fVTNs = parcelRequire("fVTNs");

var $61P2R = parcelRequire("61P2R");

var $bHD89 = parcelRequire("bHD89");


var $iJUOw = parcelRequire("iJUOw");




function $3e04fa5012c30bb4$export$875f191b05500a68(targetDate) {
    const now = Date.now();
    if (targetDate.valueOf() <= now) return 0;
    return (0, $917iu.default)(targetDate, now) + 1;
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");


var $cOrQJ = parcelRequire("cOrQJ");

var $e9278961592e4063$exports = {};
$e9278961592e4063$exports = new URL("background-dark.46d9946a.svg", import.meta.url).toString();


var $185c240d90fa12a3$exports = {};
$185c240d90fa12a3$exports = new URL("background-light.c76a8e81.svg", import.meta.url).toString();


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gNXND = parcelRequire("gNXND");


var $cyLm6 = parcelRequire("cyLm6");


var $1yB28 = parcelRequire("1yB28");


var $9Q2dU = parcelRequire("9Q2dU");


var $lebfc = parcelRequire("lebfc");


var $cDMVr = parcelRequire("cDMVr");


var $ZDq1z = parcelRequire("ZDq1z");




/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 





var $u9agA = parcelRequire("u9agA");

const $6e7b0abe9748480e$var$textWrapperStyles = {
    root: "_1reo15vq _18m915vq _o5721q9c _1bto1l2s"
};
const $6e7b0abe9748480e$var$featureLineStyles = {
    root: "_zulpu2gc _4t3i1tcg _p12f182l _4cvr1h6o"
}; /**
    * Shows an icon and feature name so as to depict a feature being compared.
    */ 
const $6e7b0abe9748480e$export$66f4bb2401604fea = ({ icon: icon, name: name, keyName: keyName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        key: keyName,
        xcss: $6e7b0abe9748480e$var$featureLineStyles.root
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $6e7b0abe9748480e$var$textWrapperStyles.root,
        key: `wrapper-${keyName}`
    }, name));





const $9b5f1583457e93b2$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    unlimitedUsers: {
        id: "recommend-standard-over-premium.feature-name-column.unlimited-users",
        defaultMessage: "Unlimited users"
    },
    pagePermissions: {
        id: "recommend-standard-over-premium.feature-name-column.page-permissions",
        defaultMessage: "Page permissions"
    },
    userPermissions: {
        id: "recommend-standard-over-premium.feature-name-column.user-permissions",
        defaultMessage: "User permissions"
    },
    freeGuestAccess: {
        id: "recommend-standard-over-premium.feature-name-column.free-guest-access",
        defaultMessage: "Free guest access"
    },
    pageInsights: {
        id: "recommend-standard-over-premium.feature-name-column.page-insights",
        defaultMessage: "Page insights"
    },
    atlassianSupport: {
        id: "recommend-standard-over-premium.feature-name-column.atlassian-support",
        defaultMessage: "Atlassian support"
    },
    rovo: {
        id: "recommend-standard-over-premium.feature-name-column.rovo",
        defaultMessage: "Rovo AI"
    },
    unlimitedAutomation: {
        id: "recommend-standard-over-premium.feature-name-column.unlimited-automation",
        defaultMessage: "Unlimited automation"
    },
    whiteboards: {
        id: "recommend-standard-over-premium.feature-name-column.whiteboards",
        defaultMessage: "Whiteboards"
    }
});


const $bfc00d1f45ce940b$var$featureNameColumnStyles = {
    root: "_1bsbdlvw _4t3ieo28 _bfhk1j9a _ca0qxncg"
}; /**
    * Returns the 6 features we show based on the product. Right now, only Confluence and Jira are supported.
    *
    * @param isConfluence Confluence if true, Jira otherwise.
    * @param formatMessage A function that can provide translations.
    */ 
function $bfc00d1f45ce940b$var$getFeatureRows(isConfluence, formatMessage) {
    const rows = [];
    rows.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6e7b0abe9748480e$export$66f4bb2401604fea), {
        key: "unlimitedUsers",
        name: formatMessage((0, $9b5f1583457e93b2$export$defe85febe8b728c).unlimitedUsers),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cDMVr))), {
            label: "",
            color: "currentColor"
        }),
        keyName: "unlimitedUsers"
    }));
    rows.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6e7b0abe9748480e$export$66f4bb2401604fea), {
        key: "permissions",
        name: isConfluence ? formatMessage((0, $9b5f1583457e93b2$export$defe85febe8b728c).pagePermissions) : formatMessage((0, $9b5f1583457e93b2$export$defe85febe8b728c).userPermissions),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
            label: "",
            color: "currentColor"
        }),
        keyName: "permissions"
    }));
    if (isConfluence) {
        rows.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6e7b0abe9748480e$export$66f4bb2401604fea), {
            key: "confluenceFreeGuestAccess",
            name: formatMessage((0, $9b5f1583457e93b2$export$defe85febe8b728c).freeGuestAccess),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lebfc))), {
                label: "",
                color: "currentColor"
            }),
            keyName: "confluenceFreeGuestAccess"
        }));
        rows.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6e7b0abe9748480e$export$66f4bb2401604fea), {
            key: "pageInsights",
            name: formatMessage((0, $9b5f1583457e93b2$export$defe85febe8b728c).pageInsights),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cyLm6))), {
                label: "",
                color: "currentColor"
            }),
            keyName: "pageInsights"
        }));
    } else {
        rows.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6e7b0abe9748480e$export$66f4bb2401604fea), {
            key: "atlassianSupport",
            name: formatMessage((0, $9b5f1583457e93b2$export$defe85febe8b728c).atlassianSupport),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                label: "",
                color: "currentColor"
            }),
            keyName: "atlassianSupport"
        }));
        rows.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6e7b0abe9748480e$export$66f4bb2401604fea), {
            key: "jiraFreeGuestAccess",
            name: formatMessage((0, $9b5f1583457e93b2$export$defe85febe8b728c).freeGuestAccess),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lebfc))), {
                label: "",
                color: "currentColor"
            }),
            keyName: "jiraFreeGuestAccess"
        }));
    }
    rows.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6e7b0abe9748480e$export$66f4bb2401604fea), {
        key: "rovo",
        name: formatMessage((0, $9b5f1583457e93b2$export$defe85febe8b728c).rovo),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gNXND))), {
            label: "",
            color: "currentColor"
        }),
        keyName: "rovo"
    }));
    rows.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6e7b0abe9748480e$export$66f4bb2401604fea), {
        key: "whiteboards",
        name: formatMessage((0, $9b5f1583457e93b2$export$defe85febe8b728c).whiteboards),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))), {
            label: "",
            color: "currentColor"
        }),
        keyName: "whiteboards"
    }));
    return rows;
}
const $bfc00d1f45ce940b$export$71214a0c3f389e20 = ({ isConfluence: isConfluence })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $bfc00d1f45ce940b$var$featureNameColumnStyles.root,
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        direction: "column",
        gap: "space.200"
    }, $bfc00d1f45ce940b$var$getFeatureRows(isConfluence, formatMessage)));
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $cO1el = parcelRequire("cO1el");


var $iXCQx = parcelRequire("iXCQx");




var $14ddd73ca7651f22$exports = {};
$14ddd73ca7651f22$exports = new URL("gestural-line-dark.9e5d1ce8.svg", import.meta.url).toString();


var $4b3347a468cb7b90$exports = {};
$4b3347a468cb7b90$exports = new URL("gestural-line.93eaf758.svg", import.meta.url).toString();





const $ada7b994182d54d8$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    recommended: {
        id: "recommend-standard-over-premium.floating-recommendation.recommended",
        defaultMessage: "Recommended"
    },
    basedOnYourUsage: {
        id: "recommend-standard-over-premium.floating-recommendation.based-on-your-usage",
        defaultMessage: "based on your usage"
    },
    gesturalLineAltText: {
        id: "recommend-standard-over-premium.floating-recommendation.gestural-line-alt-text",
        defaultMessage: "A gesture pointing towards the Standard edition"
    }
});


const $c53aaf77a9ffe8f6$var$gesturalLineStyles = {
    root: "_zulp1b66 _154i8ved _1ltv1oqx _1pbykb7n _4t3imgvx _1e0c1txw _vchhusvi _gy1p1y44 _4cvr1h6o"
};
const $c53aaf77a9ffe8f6$var$floatingTextboxStyles = {
    root: "_154i1ex1 _1ltv8ved _1bsb163w _1pbykb7n _kqswh2mm _1e0c1txw _vchhusvi _4cvr4jg8 _2lx21bp4"
}; /**
    * This the recommendation text and graphic that points out to the user that they should go for Standard.
    */ 
const $c53aaf77a9ffe8f6$export$fe8ff9b9baf3a573 = ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const isDarkMode = colorMode === 'dark';
    const gesturalLineImage = isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($14ddd73ca7651f22$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($4b3347a468cb7b90$exports)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $c53aaf77a9ffe8f6$var$floatingTextboxStyles.root
        ]),
        "data-vc": "dHp77Wzf"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "medium"
    }, formatMessage((0, $ada7b994182d54d8$export$defe85febe8b728c).recommended)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "medium"
    }, formatMessage((0, $ada7b994182d54d8$export$defe85febe8b728c).basedOnYourUsage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $c53aaf77a9ffe8f6$var$gesturalLineStyles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: gesturalLineImage,
        alt: formatMessage((0, $ada7b994182d54d8$export$defe85febe8b728c).gesturalLineAltText)
    })));
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $cvXh8 = parcelRequire("cvXh8");











const $ee76a29d8ed54666$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    premiumEdition: {
        id: "recommend-standard-over-premium.premium-edition-column.premium-edition",
        defaultMessage: "Premium"
    },
    whiteboardsUnlimited: {
        id: "recommend-standard-over-premium.premium-edition-column.whiteboards-unlimited",
        defaultMessage: "Unlmtd"
    }
});


const $62bf5f09b44c9013$var$premiumEditionColumnStyles = {
    root: "_1bsbvrzy _4t3ieo28 _bfhk1j9a _ca0qu2gc",
    textRow: "_4t3i1tcg",
    unlimitedText: "_11c8wadc _syaz1rpy"
};
const $62bf5f09b44c9013$export$42a45fd7a4ad6fa5 = ({ premiumPrice: premiumPrice })=>{
    const formattedPrice = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(premiumPrice);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $62bf5f09b44c9013$var$premiumEditionColumnStyles.root,
        direction: "column",
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        direction: "column",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        weight: "semibold",
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $ee76a29d8ed54666$export$defe85febe8b728c).premiumEdition)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        weight: "semibold",
        color: "color.text.subtlest"
    }, formattedPrice)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        direction: "column",
        gap: "space.200",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-accent-gray, #7D818A)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-accent-gray, #7D818A)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-accent-gray, #7D818A)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-accent-gray, #7D818A)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-accent-gray, #7D818A)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $62bf5f09b44c9013$var$premiumEditionColumnStyles.textRow,
        justifyContent: "center",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $62bf5f09b44c9013$var$premiumEditionColumnStyles.unlimitedText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $ee76a29d8ed54666$export$defe85febe8b728c).whiteboardsUnlimited)))));
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


















const $9f19cc056214229a$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    standardEdition: {
        id: "recommend-standard-over-premium.standard-edition-column.standard-edition",
        defaultMessage: "Standard"
    },
    whiteboardsLimited: {
        id: "recommend-standard-over-premium.standard-edition-column.whiteboards-limited",
        defaultMessage: "Limited"
    }
});


const $7b24461b71775811$var$standardEditionColumnStyles = {
    root: "_2rkolb4i _189e1dm9 _1bsbvrzy _4t3i1qwj _bfhk1j9a _ca0qutpp _16qs130s _1pbykb7n",
    textRow: "_4t3i1tcg",
    limitedText: "_11c8wadc _syazh55r"
};
const $7b24461b71775811$export$f89cbf56fa0d7030 = ({ standardPrice: standardPrice })=>{
    const formattedPrice = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(standardPrice);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $7b24461b71775811$var$standardEditionColumnStyles.root,
        direction: "column",
        alignItems: "center",
        gap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        direction: "column",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        weight: "semibold",
        color: "color.text.accent.blue.bolder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9f19cc056214229a$export$defe85febe8b728c).standardEdition)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        weight: "semibold",
        color: "color.text.accent.blue.bolder"
    }, formattedPrice)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        direction: "column",
        gap: "space.200",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-accent-green, #22A06B)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-accent-green, #22A06B)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-accent-green, #22A06B)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-accent-green, #22A06B)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-accent-green, #22A06B)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $7b24461b71775811$var$standardEditionColumnStyles.textRow,
        justifyContent: "center",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $7b24461b71775811$var$standardEditionColumnStyles.limitedText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9f19cc056214229a$export$defe85febe8b728c).whiteboardsLimited)))));
};


const $03ce69e101e0a86d$var$outerStyles = {
    root: "_1reo15vq _18m915vq"
};
const $03ce69e101e0a86d$var$panelStyles = {
    root: "_1bsb13bx _4t3isby8 _kqswstnw"
};
const $03ce69e101e0a86d$var$tableStyles = {
    root: "_154i68cl _kqswh2mm _1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $03ce69e101e0a86d$var$PanelStyleWrapper = ({ colorMode: colorMode, children: children })=>/*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $03ce69e101e0a86d$var$panelStyles.root,
        style: colorMode === 'dark' ? {
            background: `url(${0, (/*@__PURE__*/$parcel$interopDefault($e9278961592e4063$exports))}) no-repeat`
        } : {
            background: `url(${0, (/*@__PURE__*/$parcel$interopDefault($185c240d90fa12a3$exports))}) no-repeat`
        }
    }, children) /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop */ ; /**
                                                                                                                                       * This is the right side panel depicted here:
                                                                                                                                       * https://www.figma.com/design/gN2uHK0wPD93kkqExPlNeM/Confluence%3A-Recommend-Standard-to-RT-trialing-customers-(RT)?node-id=3730-11924&node-type=frame&t=ZS7oExyVxcrlRkJQ-0
                                                                                                                                       */ 
const $03ce69e101e0a86d$export$824c58e383905b7f = ({ productKey: productKey, standardPrice: standardPrice, premiumPrice: premiumPrice })=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const isConfluence = productKey === 'Confluence';
    return /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
        xcss: $03ce69e101e0a86d$var$outerStyles.root
    }, /*#__PURE__*/ $42omo.createElement((0, $c53aaf77a9ffe8f6$export$fe8ff9b9baf3a573), null), /*#__PURE__*/ $42omo.createElement($03ce69e101e0a86d$var$PanelStyleWrapper, {
        colorMode: colorMode
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $03ce69e101e0a86d$var$tableStyles.root
        ]),
        "data-vc": "p8GC5KIt"
    }, /*#__PURE__*/ $42omo.createElement((0, $bfc00d1f45ce940b$export$71214a0c3f389e20), {
        isConfluence: isConfluence
    }), /*#__PURE__*/ $42omo.createElement((0, $7b24461b71775811$export$f89cbf56fa0d7030), {
        standardPrice: standardPrice
    }), /*#__PURE__*/ $42omo.createElement((0, $62bf5f09b44c9013$export$42a45fd7a4ad6fa5), {
        premiumPrice: premiumPrice
    }))));
};





const $5c0925e6f7db5009$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    title: {
        id: "recommend-standard-over-premium.modal.title.percentage-off",
        defaultMessage: "Get everything you need for {percentageOff}% off with <purple>Standard</purple>"
    },
    subtitle: {
        id: "recommend-standard-over-premium.modal.subtitle.days-left-in-trial",
        defaultMessage: "Your Premium trial ends in {daysLeftInTrial, plural, one {# day} other {# days}}. With Standard, you get to keep essential features at a lower price."
    },
    buyStandard: {
        id: "recommend-standard-over-premium.modal.buy-standard",
        defaultMessage: "Buy Standard"
    },
    maybeLater: {
        id: "recommend-standard-over-premium.modal.maybe-later",
        defaultMessage: "Maybe later"
    }
});


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 













var $eyWa4 = parcelRequire("eyWa4");



var $3b32ff1c1bf72323$exports = {};
$3b32ff1c1bf72323$exports = new URL("strike-through.539e2da9.svg", import.meta.url).toString();





const $0c6d522fc409ae0d$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    perUserPerMonth: {
        id: "recommend-standard-over-premium.price-contrast.per-user-per-month",
        defaultMessage: "per user/month"
    },
    premiumEdition: {
        id: "recommend-standard-over-premium.price-contrast.premium-edition",
        defaultMessage: "Premium"
    },
    standardEdition: {
        id: "recommend-standard-over-premium.price-contrast.standard-edition",
        defaultMessage: "Standard"
    }
});


const $d9620f1c0bc818f2$var$outerFrameStyles = {
    root: "_bfhkysee _ca0qpxbi _n3tdpxbi _19bvu2gc _u5f31ejb _4t3ic8t1"
};
const $d9620f1c0bc818f2$var$premiumPriceStyles = {
    root: "_1wybckbl _k48pwu06 _vwz48vuz _1ul9l1r9 _kqswh2mm _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t"
};
const $d9620f1c0bc818f2$var$strikeThroughStyles = {
    root: "_154ivgba _1ltvldb6 _p12fidpf _c71lidpf _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _1pbykb7n _kqswh2mm"
};
const $d9620f1c0bc818f2$var$purpleStyles = {
    root: "_syazxpq0 _1wybckbl _k48pwu06 _vwz48vuz"
}; /**
    * This depicts the left side modal as shown here:
    * https://www.figma.com/design/gN2uHK0wPD93kkqExPlNeM/Confluence%3A-Recommend-Standard-to-RT-trialing-customers-(RT)?node-id=3730-11924&node-type=frame&t=ZS7oExyVxcrlRkJQ-0
    */ 
const $d9620f1c0bc818f2$export$f8385b6fb08b5ac4 = ({ standardPrice: standardPrice, premiumPrice: premiumPrice })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    const formattedStandardPrice = currencyFormatter.format(standardPrice);
    const formattedPremiumPrice = currencyFormatter.format(premiumPrice);
    return /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
        xcss: $d9620f1c0bc818f2$var$outerFrameStyles.root,
        gap: "space.300",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $d9620f1c0bc818f2$var$strikeThroughStyles.root
        ]),
        "data-vc": "dp6n4y-Y"
    }, /*#__PURE__*/ $42omo.createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3b32ff1c1bf72323$exports))),
        alt: "strike through"
    })), /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
        direction: "column"
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $d9620f1c0bc818f2$var$premiumPriceStyles.root
        ])
    }, formattedPremiumPrice), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.accent.gray"
    }, formatMessage((0, $0c6d522fc409ae0d$export$defe85febe8b728c).perUserPerMonth)), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), (0, $0c6d522fc409ae0d$export$defe85febe8b728c).premiumEdition))), /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), null, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), null, /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            $d9620f1c0bc818f2$var$purpleStyles.root
        ])
    }, formattedStandardPrice)), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.accent.gray"
    }, formatMessage((0, $0c6d522fc409ae0d$export$defe85febe8b728c).perUserPerMonth)), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), (0, $0c6d522fc409ae0d$export$defe85febe8b728c).standardEdition))));
};


const $242f4978bcabc2ac$var$purpleStyles = {
    root: "_syazxpq0"
};
const $242f4978bcabc2ac$export$85b369cae90e2b85 = ({ productKey: productKey, standardPrice: standardPrice, premiumPrice: premiumPrice, trialEndDate: trialEndDate, analyticsAttributes: analyticsAttributes, onClose: onClose, onClickBuyStandard: onClickBuyStandard, onOpenComplete: onOpenComplete, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const percentageOff = Math.round(100 * (1 - standardPrice / premiumPrice));
    const daysLeftInTrial = (0, $3e04fa5012c30bb4$export$875f191b05500a68)(trialEndDate);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVTNs.ContextWrapper), {
        sourceName: "recommendStandardOverPremiumModal",
        sourceType: (0, $bHD89.MODAL),
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJUOw.Modal), {
        testId: testId,
        includeCloseButton: true,
        onClose: onClose,
        onOpenComplete: onOpenComplete,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...(0, $5c0925e6f7db5009$export$defe85febe8b728c).title,
            values: {
                purple: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                        className: (0, $gMc0m.default)([
                            $242f4978bcabc2ac$var$purpleStyles.root
                        ]),
                        "data-vc": "kDpKl1xr"
                    }, chunks),
                percentageOff: percentageOff
            }
        }),
        subtitle: formatMessage((0, $5c0925e6f7db5009$export$defe85febe8b728c).subtitle, {
            daysLeftInTrial: daysLeftInTrial
        }),
        height: "536px",
        right: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $03ce69e101e0a86d$export$824c58e383905b7f), {
            productKey: productKey,
            standardPrice: standardPrice,
            premiumPrice: premiumPrice
        }),
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "subtle",
            onClick: onClose
        }, formatMessage((0, $5c0925e6f7db5009$export$defe85febe8b728c).maybeLater)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "primary",
            onClick: onClickBuyStandard
        }, formatMessage((0, $5c0925e6f7db5009$export$defe85febe8b728c).buyStandard))),
        backgroundColor: "color.background.input"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d9620f1c0bc818f2$export$f8385b6fb08b5ac4), {
        standardPrice: standardPrice,
        premiumPrice: premiumPrice
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $61P2R.FireScreenAnalytics), null)));
};



var $lsxnT = parcelRequire("lsxnT");

/* eslint-disable import-extensions/file-extension-required */ 
















var $gjUkr = parcelRequire("gjUkr");











/**
 * @generated SignedSource<<78af462abc3f664cb32da17fe6957ec6>>
 * @relayHash c0a8f920bcb634ef1fa700a213774329
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5649bc358983fe4385ab00b61e3b4e7f364bc4213918a6331132682647b49b4
const $3d6d3f0b3f757e63$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "productKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isBillToPresent"
    }, v4 = {
        "kind": "ScalarField",
        "name": "isCurrentUserBillingAdmin"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ConfluenceTransactionAccountEndOfTrialQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ConfluenceTransactionAccountEndOfTrialQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "c0a8f920bcb634ef1fa700a213774329",
            "id": "b5649bc358983fe4385ab00b61e3b4e7f364bc4213918a6331132682647b49b4",
            "metadata": {},
            "name": "ConfluenceTransactionAccountEndOfTrialQuery",
            "operationKind": "query",
            "text": "query ConfluenceTransactionAccountEndOfTrialQuery($cloudId:ID!,$productKey:String!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:$productKey){__typename,entitlement{__typename,transactionAccount{__typename,isBillToPresent,isCurrentUserBillingAdmin,...on Node{__isNode:__typename,id}},id}}}}"
        }
    };
}();
$3d6d3f0b3f757e63$var$node.hash = "6ae456392533297b4cacbb695ac5f76d";
var $3d6d3f0b3f757e63$export$2e2bcd8739ae039 = $3d6d3f0b3f757e63$var$node;


const $5227ff0456e02645$export$f430cb31e8b3d963 = (0, $3d6d3f0b3f757e63$export$2e2bcd8739ae039);





function $c2bf072169703a4e$export$b06fa80c1d4c55c1(skip, cloudId) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const canSkipQuery = skip || !cloudId;
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $5227ff0456e02645$export$f430cb31e8b3d963), {
        variables: {
            cloudId: cloudId,
            productKey: 'confluence.ondemand'
        },
        skip: canSkipQuery,
        fetchPolicy: 'cache-first',
        interopApolloAggClient: true,
        onError: (error)=>{
            const eventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
                product: (0, $gwZbZ.Product).CONFLUENCE,
                team: (0, $6o7wX.Team).GROWTH_LUNA,
                experimentMeta: {
                    experimentKey: 'twcg-530_confluence_ai_in_editor_eot'
                },
                errorType: (0, $gwZbZ.ErrorType).GRAPHQL,
                errorMessage: error?.message,
                severity: (0, $gwZbZ.Severity).MEDIUM,
                source: 'useConfluenceTransactionEndOfTrial',
                additionalAttributes: {
                    cloudId: cloudId
                }
            });
            createAnalyticsEvent(eventPayload).fire();
        },
        __callerPackage__: "@confluence/experiment-ai-in-editor-eot"
    });
    const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
    const transactionAccount = entitlement?.transactionAccount;
    const canPay = transactionAccount?.isCurrentUserBillingAdmin === true;
    const hasPaymentDetails = transactionAccount?.isBillToPresent;
    const isEligible = canPay && !hasPaymentDetails;
    return {
        loading: loading,
        error: error,
        isEligible: isEligible
    };
}


/**
 * @generated SignedSource<<c7d0548898f06ce589e9656765834d9e>>
 * @relayHash a1ee15cc9106802e3f7437a4f49138f7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0e0f01a1e0cffc5fc6577a9126fdf6e723e5ab166cb870430c91072fd5f08078
const $4723473149747c44$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "productKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v3 = {
        "concreteType": "CcpEntitlementExperienceCapabilities",
        "kind": "LinkedField",
        "name": "experienceCapabilities",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "offeringName",
                        "value": "standard"
                    },
                    {
                        "kind": "Literal",
                        "name": "skipTrial",
                        "value": true
                    }
                ],
                "concreteType": "CcpChangeOfferingExperienceCapability",
                "kind": "LinkedField",
                "name": "changeOfferingV2",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isAvailableToUser"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "experienceUrl"
                    }
                ],
                "storageKey": "changeOfferingV2(offeringName:\"standard\",skipTrial:true)"
            }
        ]
    }, v4 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Standard"
        }
    ], v5 = [
        {
            "kind": "ScalarField",
            "name": "averageAmountPerUnit"
        },
        {
            "concreteType": "CcpPricingPlanItem",
            "kind": "LinkedField",
            "name": "item",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "chargeElement"
                }
            ]
        }
    ], v6 = {
        "concreteType": "CcpListPriceEstimate",
        "kind": "LinkedField",
        "name": "listPriceForOrderWithDefaults",
        "plural": true,
        "selections": v5 /*: any*/ 
    }, v7 = {
        "concreteType": "CcpTrial",
        "kind": "LinkedField",
        "name": "trial",
        "plural": false,
        "selections": [
            {
                "concreteType": "CcpListPriceEstimate",
                "kind": "LinkedField",
                "name": "listPriceEstimates",
                "plural": true,
                "selections": v5 /*: any*/ 
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ConfluencePricingEndOfTrialPremiumToStandardQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "alias": "standardPrice",
                                                    "args": v4 /*: any*/ ,
                                                    "concreteType": "CcpEntitlementOfferingTransition",
                                                    "kind": "LinkedField",
                                                    "name": "defaultOfferingTransitions",
                                                    "plural": true,
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ],
                                                    "storageKey": "defaultOfferingTransitions(offeringName:\"Standard\")"
                                                },
                                                {
                                                    "concreteType": "CcpSubscription",
                                                    "kind": "LinkedField",
                                                    "name": "subscription",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "CcpEntitlement"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ConfluencePricingEndOfTrialPremiumToStandardQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "alias": "standardPrice",
                                                    "args": v4 /*: any*/ ,
                                                    "concreteType": "CcpEntitlementOfferingTransition",
                                                    "kind": "LinkedField",
                                                    "name": "defaultOfferingTransitions",
                                                    "plural": true,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ],
                                                    "storageKey": "defaultOfferingTransitions(offeringName:\"Standard\")"
                                                },
                                                {
                                                    "concreteType": "CcpSubscription",
                                                    "kind": "LinkedField",
                                                    "name": "subscription",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "CcpEntitlement"
                                        },
                                        v9 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "a1ee15cc9106802e3f7437a4f49138f7",
            "id": "0e0f01a1e0cffc5fc6577a9126fdf6e723e5ab166cb870430c91072fd5f08078",
            "metadata": {},
            "name": "ConfluencePricingEndOfTrialPremiumToStandardQuery",
            "operationKind": "query",
            "text": "query ConfluencePricingEndOfTrialPremiumToStandardQuery($cloudId:ID!,$productKey:String!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:$productKey){__typename,entitlement{__typename,...on CcpEntitlement{experienceCapabilities{changeOfferingV2(skipTrial:true,offeringName:\"standard\"){isAvailableToUser,experienceUrl}},standardPrice:defaultOfferingTransitions(offeringName:\"Standard\"){listPriceForOrderWithDefaults{averageAmountPerUnit,item{chargeElement}},id},subscription{trial{listPriceEstimates{averageAmountPerUnit,item{chargeElement}}},id}},id}}}}"
        }
    };
}();
$4723473149747c44$var$node.hash = "689ba1aea16ebc0b8b7c30d1915df2c7";
var $4723473149747c44$export$2e2bcd8739ae039 = $4723473149747c44$var$node;


const $d42c8d4b0d08c064$export$a10572f6d01f7af = (0, $4723473149747c44$export$2e2bcd8739ae039);





/* eslint-disable import-extensions/file-extension-required */ 
var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");

const $a3d379c5382ffbdd$export$83457a6c00af4df7 = (error)=>{
    if (!error) return undefined;
    if ((0, $1uFM6.isUnauthorizedError)(error)) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    }
    return error;
};


function $f9965b963a799934$export$b51cb4e416b80afa(skip) {
    const { cloudId: cloudId, isLoggedIn: isLoggedIn, edition: edition } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const canSkipTransactionQuery = skip || !cloudId || !isLoggedIn || !edition || edition !== (0, $euL71.ConfluenceEdition).PREMIUM;
    const { isEligible: transactionAccountEligible, loading: transactionAccountLoading, error: transactionAccountError } = (0, $c2bf072169703a4e$export$b06fa80c1d4c55c1)(canSkipTransactionQuery, cloudId);
    const canSkipQuery = canSkipTransactionQuery || transactionAccountLoading || !!transactionAccountError || !transactionAccountEligible;
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $d42c8d4b0d08c064$export$a10572f6d01f7af), {
        variables: {
            cloudId: cloudId,
            productKey: 'confluence.ondemand'
        },
        skip: canSkipQuery,
        fetchPolicy: 'cache-first',
        // for SSR'ing purposes
        interopApolloAggClient: true,
        errorPolicy: 'all',
        __callerPackage__: "@confluence/experiment-ai-in-editor-eot"
    });
    const processedError = (0, $a3d379c5382ffbdd$export$83457a6c00af4df7)(error);
    if (processedError) {
        const eventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
            product: (0, $gwZbZ.Product).CONFLUENCE,
            team: (0, $6o7wX.Team).GROWTH_LUNA,
            experimentMeta: {
                experimentKey: 'twcg-530_confluence_ai_in_editor_eot'
            },
            errorType: (0, $gwZbZ.ErrorType).GRAPHQL,
            errorMessage: processedError?.message,
            severity: (0, $gwZbZ.Severity).MEDIUM,
            source: 'usePricingEOTPremiumToStandardQuery',
            additionalAttributes: {
                cloudId: cloudId
            }
        });
        createAnalyticsEvent(eventPayload).fire();
    }
    const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
    const isAvailableToUser = entitlement?.experienceCapabilities?.changeOfferingV2?.isAvailableToUser ?? false;
    if (canSkipQuery || !entitlement || !isAvailableToUser) return {
        data: null,
        loading: loading,
        error: processedError
    };
    const experienceUrl = (0, $gjUkr.addAtlOriginToUrl)(entitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl ?? '');
    let standardEditionPrice;
    let premiumEditionPrice;
    if (!canSkipQuery && entitlement) {
        const premiumEditionOrder = entitlement?.subscription?.trial;
        premiumEditionPrice = premiumEditionOrder?.listPriceEstimates?.find((item)=>item?.item?.chargeElement === 'user')?.averageAmountPerUnit;
        const standardEditionOrder = entitlement?.standardPrice?.find((orderItem)=>orderItem?.listPriceForOrderWithDefaults && orderItem?.listPriceForOrderWithDefaults?.length > 0);
        standardEditionPrice = standardEditionOrder?.listPriceForOrderWithDefaults?.find((item)=>item?.item?.chargeElement === 'user')?.averageAmountPerUnit;
    }
    return {
        loading: loading,
        error: processedError,
        data: {
            userCanAddPaymentDetails: transactionAccountEligible,
            experienceUrl: experienceUrl,
            standardPrice: standardEditionPrice ? standardEditionPrice / 100 : 6.7,
            premiumPrice: premiumEditionPrice ? premiumEditionPrice / 100 : 13.2
        }
    };
}



var $bdMSP = parcelRequire("bdMSP");


var $bxAaA = parcelRequire("bxAaA");





const $e37074a784a62c89$export$baa48889c42cc6cb = ()=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(true);
    const handleClose = ()=>{
        setIsOpen(false);
    };
    return {
        isOpen: isOpen,
        handleClose: handleClose
    };
};


const $2a6a650213457502$export$f1384e9eeb5f02e3 = ({ trialEndDate: trialEndDate, trialDaysLeft: trialDaysLeft })=>{
    const { dismissedEndOfTrialModal: dismissedEndOfTrialModal, clickedEndOfTrialPrimaryCTA: clickedEndOfTrialPrimaryCTA } = (0, $bxAaA.useAnalytics)();
    const { useChoreographedRender: useChoreographedRender } = (0, $lsxnT.useChoreographerAssets)();
    const shouldRenderMyComponent = useChoreographedRender({
        messageId: 'experiment-ai-in-editor-end-of-trial-modal-container'
    });
    const { data: endOfTrialData, loading: loading, error: error } = (0, $f9965b963a799934$export$b51cb4e416b80afa)(!shouldRenderMyComponent);
    const { isOpen: isOpen, handleClose: handleClose } = (0, $e37074a784a62c89$export$baa48889c42cc6cb)();
    const isEligible = Boolean(endOfTrialData && shouldRenderMyComponent && !loading && !error && endOfTrialData.userCanAddPaymentDetails && endOfTrialData.experienceUrl && endOfTrialData.premiumPrice && endOfTrialData.standardPrice && isOpen);
    const { isABTreatment: isABTreatment } = (0, $bdMSP.useEnrolledAIInEditorModalsExperiment)({
        isEligible: isEligible,
        touchpoint: 'end-of-trial',
        trialDaysLeft: trialDaysLeft
    });
    if (!endOfTrialData) return null;
    const { experienceUrl: experienceUrl, premiumPrice: premiumPrice, standardPrice: standardPrice } = endOfTrialData;
    if (!isEligible || !isABTreatment || !endOfTrialData || loading || error || !experienceUrl || !premiumPrice || !standardPrice) return null;
    const handleDismiss = ()=>{
        handleClose();
        (0, $192f920b4c5c17aa$export$56a11e91bcd97371)();
        dismissedEndOfTrialModal();
    };
    const handlePrimaryCTAClick = ()=>{
        handleClose();
        window.open(experienceUrl, '_blank');
        (0, $192f920b4c5c17aa$export$56a11e91bcd97371)();
        clickedEndOfTrialPrimaryCTA();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
        locale: "en",
        messages: {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $242f4978bcabc2ac$export$85b369cae90e2b85), {
        analyticsAttributes: {},
        onClickBuyStandard: handlePrimaryCTAClick,
        onClose: handleDismiss,
        premiumPrice: premiumPrice,
        productKey: "Confluence",
        standardPrice: standardPrice,
        trialEndDate: new Date(trialEndDate)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bxAaA.ScreenEvent), {
        name: "endOfTrialModal"
    })));
};


const $a0725fa76ab9c161$var$EndOfTrialModalContainer = ()=>{
    const { hasEligibleTrial: hasEligibleTrial, loading: loading, error: error, trialEndDate: trialEndDate, trialDaysLeft: trialDaysLeft } = (0, $81c1a978552640a6$export$43c4a046864c3310)();
    if (loading || error || !trialEndDate || !trialDaysLeft) return null;
    if (!(0, $192f920b4c5c17aa$export$145498fa852fa1d4)(trialEndDate, trialDaysLeft)) return null;
    if (hasEligibleTrial) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2a6a650213457502$export$f1384e9eeb5f02e3), {
        trialEndDate: trialEndDate,
        trialDaysLeft: trialDaysLeft
    });
};
function $a0725fa76ab9c161$export$ae6e7134e853158f() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH_LUNA,
        onError: (error, info)=>{
            const eventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
                product: (0, $gwZbZ.Product).CONFLUENCE,
                team: (0, $6o7wX.Team).GROWTH_LUNA,
                experimentMeta: {
                    experimentKey: 'twcg-530_confluence_ai_in_editor_eot'
                },
                errorMessage: error.message,
                errorType: (0, $gwZbZ.ErrorType).ERROR_BOUNDARY,
                severity: (0, $gwZbZ.Severity).MEDIUM,
                source: 'EndOfTrialModalContainer',
                additionalAttributes: {
                    ...info
                }
            });
            createAnalyticsEvent(eventPayload).fire();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a0725fa76ab9c161$var$EndOfTrialModalContainer, null));
}
module.exports["EndOfTrialModalContainerWithErrorBoundary"] = $a0725fa76ab9c161$export$ae6e7134e853158f;

});

parcelRegister("8hmrm", function(module, exports) {

var $gwZbZ = parcelRequire("gwZbZ");


var $gvWCD = parcelRequire("gvWCD");


var $3HIy9 = parcelRequire("3HIy9");


var $39G0n = parcelRequire("39G0n");

const $31b517e9b4290477$export$8c06ae8e7f403dea = ({ product: product, team: team, experimentMeta: experimentMeta, errorType: errorType, errorMessage: errorMessage, source: source, severity: severity, additionalAttributes: additionalAttributes = {} }, isActiveExperiment = true)=>{
    (0, $39G0n.validateExperimentName)(experimentMeta.experimentKey);
    const eventPayload = (0, $gvWCD.createEventPayload)({
        team: team,
        experimentMeta: experimentMeta,
        errorType: errorType,
        errorMessage: errorMessage,
        source: source,
        severity: severity,
        isActiveExperiment: isActiveExperiment,
        additionalAttributes: additionalAttributes,
        product: product
    });
    switch(product){
        case (0, $gwZbZ.Product).ADMIN_HUB:
            return {
                data: eventPayload
            };
        case (0, $gwZbZ.Product).JIRA:
            return {
                data: eventPayload,
                productSpecificRules: {
                    jira: {
                        createAnalyticsEventPayload: (0, $3HIy9.convertEventPayloadForJiraCreateAnalyticsEvent)({
                            data: eventPayload
                        }),
                        fireEventPayload: (0, $3HIy9.convertEventAttributesForJiraFireEvent)({
                            data: eventPayload
                        })
                    }
                }
            };
        case (0, $gwZbZ.Product).CONFLUENCE:
            return {
                type: (0, $gwZbZ.CONFLUENCE_OPERATIONAL_EVENT_TYPE),
                data: eventPayload
            };
        default:
            throw new Error(`Unsupported product: ${product}`);
    }
};
module.exports["createProductSpecificAnalyticsIntegrationPayload"] = $31b517e9b4290477$export$8c06ae8e7f403dea;

});

parcelRegister("gwZbZ", function(module, exports) {
const $64e202edaa8eb03b$export$ec4825154d679381 = 'error';
const $64e202edaa8eb03b$export$a924d1f92c0e2e78 = 'growth-experiment';
const $64e202edaa8eb03b$export$e5025d93161b0712 = 'sendOperationalEvent';
const $64e202edaa8eb03b$export$5c3e8a6b8e7ba45b = 'growth-error-analytics';
var $64e202edaa8eb03b$export$264ad599d7cef668 = /*#__PURE__*/ function(Product) {
    Product["JIRA"] = "jira";
    Product["CONFLUENCE"] = "confluence";
    Product["ADMIN_HUB"] = "admin-hub";
    return Product;
}({});
var $64e202edaa8eb03b$export$dba1278861bf0dc1 = /*#__PURE__*/ function(ErrorType) {
    ErrorType["GRAPHQL"] = "graphql";
    ErrorType["REST"] = "rest";
    ErrorType["ERROR_BOUNDARY"] = "error-boundary";
    ErrorType["GENERIC"] = "generic";
    return ErrorType;
}({});
var $64e202edaa8eb03b$export$918a9776c0a3cf27 = /*#__PURE__*/ function(Severity) {
    Severity["LOW"] = "low";
    Severity["MEDIUM"] = "medium";
    Severity["HIGH"] = "high";
    return Severity;
}({});
const $64e202edaa8eb03b$export$a61493d7ab73936 = 'growth';
module.exports["ERROR_ACTION"] = $64e202edaa8eb03b$export$ec4825154d679381;
module.exports["ERROR_ACTION_SUBJECT"] = $64e202edaa8eb03b$export$a924d1f92c0e2e78;
module.exports["CONFLUENCE_OPERATIONAL_EVENT_TYPE"] = $64e202edaa8eb03b$export$e5025d93161b0712;
module.exports["Product"] = $64e202edaa8eb03b$export$264ad599d7cef668;
module.exports["ErrorType"] = $64e202edaa8eb03b$export$dba1278861bf0dc1;
module.exports["Severity"] = $64e202edaa8eb03b$export$918a9776c0a3cf27;
module.exports["EVENT_TAG_GROWTH"] = $64e202edaa8eb03b$export$a61493d7ab73936;

});

parcelRegister("gvWCD", function(module, exports) {

var $gwZbZ = parcelRequire("gwZbZ");

const $d2a9f5f63821177b$export$f2a94361d01a626c = ({ team: team, experimentMeta: experimentMeta, errorType: errorType, errorMessage: errorMessage, source: source, severity: severity, isActiveExperiment: isActiveExperiment, product: product, additionalAttributes: additionalAttributes = {} })=>{
    const actionSubjectId = `${(0, $gwZbZ.ERROR_ACTION_SUBJECT)}-${experimentMeta.experimentKey}-${errorType}`;
    return {
        action: (0, $gwZbZ.ERROR_ACTION),
        actionSubject: (0, $gwZbZ.ERROR_ACTION_SUBJECT),
        actionSubjectId: actionSubjectId,
        source: experimentMeta.experimentKey,
        attributes: {
            errorType: errorType,
            team: team,
            experimentKey: experimentMeta.experimentKey,
            cohort: experimentMeta?.cohort,
            severity: severity,
            errorMessage: errorMessage,
            isActiveExperiment: isActiveExperiment,
            product: product,
            detailedSource: source,
            ...additionalAttributes
        },
        tags: [
            (0, $gwZbZ.EVENT_TAG_GROWTH)
        ]
    };
};
module.exports["createEventPayload"] = $d2a9f5f63821177b$export$f2a94361d01a626c;

});

parcelRegister("3HIy9", function(module, exports) {

var $gwZbZ = parcelRequire("gwZbZ");


var $8hmrm = parcelRequire("8hmrm");

const $de70a0c4deb210a2$export$d5090ca98c07c12d = (payload)=>{
    const { data: data } = payload;
    return {
        action: data.action,
        actionSubject: data.actionSubject,
        source: data.source,
        actionSubjectId: data.actionSubjectId,
        tags: data.tags
    };
};
const $de70a0c4deb210a2$export$2144cc21b87dd554 = (payload)=>{
    const { data: data } = payload;
    const eventName = `${data.actionSubject} ${data.action}`;
    return {
        eventName: eventName,
        attributes: data.attributes
    };
};
const $de70a0c4deb210a2$export$f106561f47f05126 = (event)=>{
    const { payload: payload } = event;
    // Extract attributes from the event payload and create a formatted payload
    // specifically for Jira product integration
    const analyticsEventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
        product: (0, $gwZbZ.Product).JIRA,
        team: payload.attributes.team,
        experimentMeta: {
            experimentKey: payload.attributes.experimentKey,
            cohort: payload.attributes.cohort
        },
        errorType: payload.attributes.errorType,
        errorMessage: payload.attributes.errorMessage,
        source: payload.attributes.source,
        severity: payload.attributes.severity
    });
    // Return both payload formats needed for complete Jira analytics integration:
    // 1. createEventPayload: Used with Jira's createAnalyticsEvent
    // 2. fireEventPayload: Used with Jira's fireEvent
    return {
        createEventPayload: $de70a0c4deb210a2$export$d5090ca98c07c12d(analyticsEventPayload),
        fireEventPayload: $de70a0c4deb210a2$export$2144cc21b87dd554(analyticsEventPayload)
    };
};
module.exports["convertEventPayloadForJiraCreateAnalyticsEvent"] = $de70a0c4deb210a2$export$d5090ca98c07c12d;
module.exports["convertEventAttributesForJiraFireEvent"] = $de70a0c4deb210a2$export$2144cc21b87dd554;

});

parcelRegister("39G0n", function(module, exports) {
/**
 * Validates that an experiment name doesn't contain spaces.
 * Experiment names with spaces can cause issues in dashboards and analytics tracking.
 *
 * @param experimentName The experiment name to validate
 * @throws Error if experiment name contains spaces
 */ const $34ecc222054f7431$export$7fa6b5da621cbeb2 = (experimentName)=>{
    if (experimentName.includes(' ')) throw new Error(`Experiment name "${experimentName}" contains spaces. ` + 'Experiment names must not contain spaces to ensure proper tracking in dashboards. ' + 'Use camelCase or hyphens instead (e.g., "myExperiment" or "my-experiment").');
};
module.exports["validateExperimentName"] = $34ecc222054f7431$export$7fa6b5da621cbeb2;

});

parcelRegister("6o7wX", function(module, exports) {
/**
 * Enumeration of authorized teams for growth error analytics
 *
 * IMPORTANT: If your team wants to use growth-commons-error-analytics:
 * 1. Add your team name following the convention 'TEAM_NAME = team-name'
 * 2. Create a PR and request review from the #growth-luna channel
 * 3. Provide context about your team and use case in the PR description
 *
 * The growth-luna team reviews all additions to maintain analytics quality
 * and ensure proper integration with dashboards.
 *
 * @example
 * // Adding a new team:
 * // GROWTH_NEW_TEAM = 'growth-new-team', // requires approval
 */ var $7d6dde24ede24951$export$3e5d0af8e738b082 = /*#__PURE__*/ function(Team) {
    Team["GROWTH_LUNA"] = "growth-luna";
    return Team;
}({});
module.exports["Team"] = $7d6dde24ede24951$export$3e5d0af8e738b082;

});

parcelRegister("gh2Ps", function(module, exports) {

var $86J3m = parcelRequire("86J3m");

const $d8877998447b08ad$export$ffea68d0e1e6677a = (0, $86J3m.default);
module.exports["PremiumTrialEotQuery"] = $d8877998447b08ad$export$ffea68d0e1e6677a;

});

parcelRegister("86J3m", function(module, exports) {
/**
 * @generated SignedSource<<fc7e767fc051822f59eef1055150d862>>
 * @relayHash a201e35c52930069bd3f531056f85a1e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d2c40c3d1db75173e20637646a4b20589cc3fd8382e93142c654bcc179c8b4dc
const $56a08c83ca1da91a$var$node = function() {
    var v0 = [
        {
            "concreteType": "License",
            "kind": "LinkedField",
            "name": "license",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "billingSourceSystem"
                },
                {
                    "kind": "ScalarField",
                    "name": "trialEndDate"
                },
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "PremiumTrialEotQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "PremiumTrialEotQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "a201e35c52930069bd3f531056f85a1e",
            "id": "d2c40c3d1db75173e20637646a4b20589cc3fd8382e93142c654bcc179c8b4dc",
            "metadata": {},
            "name": "PremiumTrialEotQuery",
            "operationKind": "query",
            "text": "query PremiumTrialEotQuery{license{billingSourceSystem,trialEndDate,__typename}}"
        }
    };
}();
$56a08c83ca1da91a$var$node.hash = "622a72cff34d40ab317dff21b5897ed5";
var $56a08c83ca1da91a$export$2e2bcd8739ae039 = $56a08c83ca1da91a$var$node;
module.exports["default"] = $56a08c83ca1da91a$export$2e2bcd8739ae039;

});

parcelRegister("cTaz1", function(module, exports) {
$parcel$export(module.exports, "default", () => $9622d0df3fc5e743$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $9622d0df3fc5e743$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    return (0, $egXhZ.default)(dirtyDate).getTime() > Date.now();
}

});

parcelRegister("fVTNs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $e7URT = parcelRequire("e7URT");


var $1j3sF = parcelRequire("1j3sF");


var $bYRk6 = parcelRequire("bYRk6");

const $c32683c3f1554789$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1j3sF)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($e7URT))));
};
const $c32683c3f1554789$export$34282a1f95511a11 = (props)=>{
    const data = $c32683c3f1554789$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.children));
};
module.exports["ContextWrapper"] = $c32683c3f1554789$export$34282a1f95511a11;

});

parcelRegister("61P2R", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1DWH0 = parcelRequire("1DWH0");


var $bHD89 = parcelRequire("bHD89");


var $3C50A = parcelRequire("3C50A");

const $a3a7b6cd19e2461a$var$getFixedActionAndActionSubject = (props)=>{
    const { eventName: eventName, action: action, actionSubject: actionSubject } = props;
    if (eventName && (action || actionSubject)) throw new Error('eventName is an alias for action & actionSubject, provide only one of those');
    const eventNameSplit = eventName ? eventName.split(' ') : [];
    const fixedAction = action || eventNameSplit[1];
    const fixedActionSubject = actionSubject || eventNameSplit[0];
    if (!fixedAction || !fixedActionSubject) throw new Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
    return {
        action: fixedAction,
        actionSubject: fixedActionSubject
    };
};
const $a3a7b6cd19e2461a$var$getFixedActionSubjectId = (props)=>{
    const { componentName: componentName, actionSubjectId: actionSubjectId } = props;
    if (componentName && actionSubjectId) throw new Error('componentName is an alias for actionSubjectId, provide only one of those');
    const fixedActionSubjectId = actionSubjectId || componentName;
    return {
        actionSubjectId: fixedActionSubjectId
    };
};
class $a3a7b6cd19e2461a$var$FireComponent extends (0, $42omo.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes } = this.props;
        if (!this.props.createAnalyticsEvent) throw new Error('Invalid use of component; must be wrapped by withAnalyticsEvents HOC');
        const { action: action, actionSubject: actionSubject } = $a3a7b6cd19e2461a$var$getFixedActionAndActionSubject(this.props);
        const { actionSubjectId: actionSubjectId } = $a3a7b6cd19e2461a$var$getFixedActionSubjectId(this.props);
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $3C50A.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $a3a7b6cd19e2461a$var$WithAnalytics = (0, $1DWH0.default)()($a3a7b6cd19e2461a$var$FireComponent);
const $a3a7b6cd19e2461a$export$1f3555c9be6c5e08 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a3a7b6cd19e2461a$var$WithAnalytics, {
        ...props,
        type: (0, $bHD89.UI_EVENT_TYPE)
    });
const $a3a7b6cd19e2461a$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a3a7b6cd19e2461a$var$WithAnalytics, {
        ...props,
        type: (0, $bHD89.TRACK_EVENT_TYPE)
    });
const $a3a7b6cd19e2461a$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a3a7b6cd19e2461a$var$WithAnalytics, {
        ...props,
        type: (0, $bHD89.OPERATIONAL_EVENT_TYPE)
    });
const $a3a7b6cd19e2461a$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a3a7b6cd19e2461a$var$WithAnalytics, {
        ...props,
        type: (0, $bHD89.SCREEN_EVENT_TYPE),
        eventName: "screen viewed"
    });
module.exports["FireOperationalAnalytics"] = $a3a7b6cd19e2461a$export$b71c3ada5d4ec5da;
module.exports["FireScreenAnalytics"] = $a3a7b6cd19e2461a$export$2ccf161b817b43b;

});

parcelRegister("iJUOw", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $8TTLA = parcelRequire("8TTLA");

var $8CZUH = parcelRequire("8CZUH");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $59OcG = parcelRequire("59OcG");


var $4gAvD = parcelRequire("4gAvD");


var $lJwTu = parcelRequire("lJwTu");

const $a38eaca20b61fcf5$var$styles = {
    hasSideContentContainer: "_2rkog72m _kqswh2mm _18m91wug _4t3i1osq _dm2511p5 _1rqtwxkt",
    baseContainer: "_kqswh2mm",
    stack: "_4t3i1osq _ca0qoahv _u5f3oahv _n3tdoahv _19bvoahv _18m91wug",
    sideContainer: "_1e0cglyw _4ap3ysee _dm251txw _glte1osq _1mbp1wug",
    leftSideContainer: "_st56g72m _ht3kg72m",
    rightSideContainer: "_o0bag72m _zsqyg72m",
    closeButton: "_kqswstnw _154ipxbi _1xi2pxbi _1pbykb7n"
};
const $a38eaca20b61fcf5$export$2b77a92f1a5ad772 = ({ renderedInsideEntrypoint: renderedInsideEntrypoint, backgroundColor: backgroundColor, ...modalProps })=>{
    const hasSideContent = !!modalProps.right || !!modalProps.sideContent;
    if (renderedInsideEntrypoint) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($a38eaca20b61fcf5$var$styles.baseContainer, hasSideContent && $a38eaca20b61fcf5$var$styles.hasSideContentContainer),
        backgroundColor: backgroundColor,
        style: {
            height: modalProps.height
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a38eaca20b61fcf5$var$ModalContent, modalProps));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
        width: hasSideContent ? 'x-large' : undefined,
        ...modalProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($a38eaca20b61fcf5$var$styles.baseContainer, hasSideContent && $a38eaca20b61fcf5$var$styles.hasSideContentContainer),
        backgroundColor: backgroundColor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a38eaca20b61fcf5$var$ModalContent, modalProps)));
};
const $a38eaca20b61fcf5$var$ModalContent = ({ logo: logo, title: title, subtitle: subtitle, subtitleColor: subtitleColor = 'color.text.subtle', children: children, actions: actions, primaryAction: primaryAction, secondaryAction: secondaryAction, right: right, sideContent: sideContent, sideLocation: sideLocation = 'right', includeCloseButton: includeCloseButton = false, onClose: onClose })=>{
    const rightContent = right ?? (sideLocation === 'right' ? sideContent : undefined);
    const leftContent = !right && sideLocation === 'left' ? sideContent : undefined;
    const safeOnClose = typeof onClose === 'function' ? onClose : ()=>{};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, includeCloseButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $a38eaca20b61fcf5$var$styles.closeButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
        testId: "modal-close-button",
        onClick: safeOnClose
    })), !!leftContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($a38eaca20b61fcf5$var$styles.sideContainer, $a38eaca20b61fcf5$var$styles.leftSideContainer)
    }, leftContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.400",
        xcss: $a38eaca20b61fcf5$var$styles.stack
    }, logo, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lJwTu.ModalTitle), null, title), subtitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: subtitleColor,
        size: "medium"
    }, subtitle) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $59OcG.ModalBody), null, children), actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4gAvD.ModalFooter), null, actions) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4gAvD.ModalFooter), null, secondaryAction, primaryAction)), !!rightContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($a38eaca20b61fcf5$var$styles.sideContainer, $a38eaca20b61fcf5$var$styles.rightSideContainer)
    }, rightContent));
};
module.exports["Modal"] = $a38eaca20b61fcf5$export$2b77a92f1a5ad772;

});

parcelRegister("59OcG", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $crya1 = parcelRequire("crya1");


var $804cB = parcelRequire("804cB");


var $eyWa4 = parcelRequire("eyWa4");

const $4494e4f87dd19321$var$styles = {
    container: "_16jlkb7n _1o9zkb7n _i0dl1wug _18m91wug"
};
const $4494e4f87dd19321$export$cb540d8b0ef7906c = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $804cB.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crya1.TouchScrollable), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4494e4f87dd19321$var$ScrollableBody, {
        testId: testId
    }, children));
};
const $4494e4f87dd19321$var$ScrollableBody = /*#__PURE__*/ (0, $42omo.forwardRef)(({ testId: testId, children: children }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.300",
        xcss: $4494e4f87dd19321$var$styles.container,
        testId: testId,
        ref: ref
    }, children);
});
module.exports["ModalBody"] = $4494e4f87dd19321$export$cb540d8b0ef7906c;

});

parcelRegister("4gAvD", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $804cB = parcelRequire("804cB");


var $u9agA = parcelRequire("u9agA");

const $f0cb77ae0ad3836b$var$styles = {
    wrap: "_1n261tfl"
};
const $f0cb77ae0ad3836b$export$519437715052e656 = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $804cB.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignInline: "end",
        testId: testId,
        space: "space.150",
        xcss: $f0cb77ae0ad3836b$var$styles.wrap
    }, children);
};
module.exports["ModalFooter"] = $f0cb77ae0ad3836b$export$519437715052e656;

});

parcelRegister("lJwTu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cO1el = parcelRequire("cO1el");


var $804cB = parcelRequire("804cB");

const $b97fbf5d6df63832$export$b26fae16ba5468aa = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { titleId: titleId, testId: modalTestId } = (0, $804cB.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        testId: testId,
        size: "large",
        id: titleId
    }, children);
};
module.exports["ModalTitle"] = $b97fbf5d6df63832$export$b26fae16ba5468aa;

});

parcelRegister("gjUkr", function(module, exports) {

var $6Co6F = parcelRequire("6Co6F");

const $10cc0a048087d5da$export$27aa48a6b5521530 = (url)=>{
    if (!url) return '';
    const origin = new (0, $6Co6F.default)({
        product: 'confluence'
    });
    return origin.addToUrl(url);
};
module.exports["addAtlOriginToUrl"] = $10cc0a048087d5da$export$27aa48a6b5521530;

});

parcelRegister("bdMSP", function(module, exports) {
/* eslint-disable confluence-feature-gating/prefer-exp-val-equals */ 
var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $6mKj3 = parcelRequire("6mKj3");

const $81f1ccd13ae0eba6$export$c2005d7fb3853502 = ({ touchpoint: touchpoint, isEligible: isEligible, extraAnalyticsAttributes: extraAnalyticsAttributes = {}, trialDaysLeft: trialDaysLeft })=>{
    const memoizedAnalyticsAttributes = (0, $42omo.useMemo)(()=>extraAnalyticsAttributes, [
        extraAnalyticsAttributes
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hasFiredEventsRef = (0, $42omo.useRef)({
        ab: new Set()
    });
    const experimentValues = (0, $42omo.useMemo)(()=>{
        if (!isEligible) return {
            isABTreatment: false
        };
        if ((0, $6mKj3.expVal)('twcg-530_confluence_ai_in_editor_eot', 'cohort', 'not-enrolled') !== 'not-enrolled') return {
            isABTreatment: (0, $6mKj3.expVal)('twcg-530_confluence_ai_in_editor_eot', 'cohort', 'not-enrolled') === 'treatment'
        };
        return {
            isABTreatment: false
        };
    }, [
        isEligible
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isEligible) return;
        if (!hasFiredEventsRef.current.ab.has(touchpoint) && (0, $6mKj3.expVal)('twcg-530_confluence_ai_in_editor_eot', 'cohort', 'not-enrolled') !== 'not-enrolled') {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'exposed',
                    actionSubject: 'experiment',
                    actionSubjectId: `twcg-530_confluence_ai_in_editor_eot-exposed`,
                    attributes: {
                        cohort: (0, $6mKj3.expVal)('twcg-530_confluence_ai_in_editor_eot', 'cohort', 'not-enrolled'),
                        touchpoint: touchpoint,
                        trialDaysLeft: trialDaysLeft,
                        ...memoizedAnalyticsAttributes
                    },
                    source: 'twcg-530_confluence_ai_in_editor_eot'
                }
            }).fire();
            hasFiredEventsRef.current.ab.add(touchpoint);
        }
    }, [
        isEligible,
        touchpoint,
        memoizedAnalyticsAttributes,
        createAnalyticsEvent,
        trialDaysLeft
    ]);
    return experimentValues;
};
module.exports["useEnrolledAIInEditorModalsExperiment"] = $81f1ccd13ae0eba6$export$c2005d7fb3853502;

});

parcelRegister("bxAaA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $9bd2a766fc04371e$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sendAnalyticEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire();
    }, [
        createAnalyticsEvent
    ]);
    const clickedAIInEditorPrimaryCTA = (0, $42omo.useCallback)(()=>{
        sendAnalyticEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'clickedAIInEditorPrimaryCTA',
                source: 'twcg-530_confluence_ai_in_editor_eot'
            }
        });
    }, [
        sendAnalyticEvent
    ]);
    const clickedEndOfTrialPrimaryCTA = (0, $42omo.useCallback)(()=>{
        sendAnalyticEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'clickedEndOfTrialPrimaryCTA',
                source: 'twcg-530_confluence_ai_in_editor_eot'
            }
        });
    }, [
        sendAnalyticEvent
    ]);
    const dismissedAIInEditorModal = (0, $42omo.useCallback)(()=>{
        sendAnalyticEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismissedConfluenceAiInEditorModal',
                source: 'twcg-530_confluence_ai_in_editor_eot'
            }
        });
    }, [
        sendAnalyticEvent
    ]);
    const dismissedEndOfTrialModal = (0, $42omo.useCallback)(()=>{
        sendAnalyticEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismissedConfluenceEndOfTrialModal',
                source: 'twcg-530_confluence_ai_in_editor_eot'
            }
        });
    }, [
        sendAnalyticEvent
    ]);
    return {
        sendAnalyticEvent: sendAnalyticEvent,
        dismissedAIInEditorModal: dismissedAIInEditorModal,
        dismissedEndOfTrialModal: dismissedEndOfTrialModal,
        clickedAIInEditorPrimaryCTA: clickedAIInEditorPrimaryCTA,
        clickedEndOfTrialPrimaryCTA: clickedEndOfTrialPrimaryCTA
    };
};
const $9bd2a766fc04371e$export$b901544a79a3bbad = ({ name: name })=>{
    const { sendAnalyticEvent: sendAnalyticEvent } = $9bd2a766fc04371e$export$e955abb82869dc84();
    const hasSent = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasSent.current) return;
        hasSent.current = true;
        sendAnalyticEvent({
            type: 'sendScreenEvent',
            data: {
                name: name,
                source: 'twcg-530_confluence_ai_in_editor_eot'
            }
        });
    }, [
        sendAnalyticEvent,
        name
    ]);
    return null;
};
module.exports["useAnalytics"] = $9bd2a766fc04371e$export$e955abb82869dc84;
module.exports["ScreenEvent"] = $9bd2a766fc04371e$export$b901544a79a3bbad;

});


//# sourceMappingURL=EndOfTrialModalContainer.60eac99e.js.map
